<app-loader [isBusy]="isBusy">
    <ng-template>
        <div class="modal-header">
            <h4 class="modal-title">
                {{ isEditMode ? ('Edit Delivery Order Item' | translate) : ('Add Delivery Order Items' | translate) }}
            </h4>
            <button class="close" type="button" aria-label="Close" (click)="activeModal.close(null)">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body">
            <app-loader [isBusy]="false">
                <ng-template>
                    <form [formGroup]="form">
                        <div formArrayName="items">
                            @for (grp of itemsArray.controls; track grp; let i = $index) {
                                <div class="mb-3" [formGroupName]="i">
                                    <div class="row align-items-end">
                                        <div class="col-6">
                                            <form-textbox
                                                formControlName="name"
                                                labelText="{{ 'Name' | translate }}"></form-textbox>
                                        </div>
                                        <div [ngClass]="isEditMode ? 'col-3' : 'col-5'">
                                            <form-number
                                                formControlName="quantity"
                                                labelText="{{ 'Quantity' | translate }}"
                                                [emptyIfZero]="true"></form-number>
                                        </div>
                                        @if (isEditMode) {
                                            <div class="col-3">
                                                <form-textbox
                                                    formControlName="sequenceNbr"
                                                    labelText="{{ 'Sequence Number' | translate }}"
                                                    [isDisabled]="true"></form-textbox>
                                            </div>
                                        }
                                        @if (!isEditMode) {
                                            <div class="col-md-1 d-flex justify-content-center mb-3">
                                                <button class="btn btn-sm btn-danger" (click)="removeItem(i)">
                                                    <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                                                </button>
                                            </div>
                                        }
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <form-textbox
                                                formControlName="description"
                                                labelText="{{ 'Description' | translate }}"></form-textbox>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <form-number
                                                formControlName="grossWeight"
                                                labelText="{{ 'Gross Weight (kg)' | translate }}"
                                                [emptyIfZero]="true"
                                                [decimal]="true"></form-number>
                                        </div>
                                        <div class="col">
                                            <form-number
                                                formControlName="netWeight"
                                                labelText="{{ 'Net Weight (kg)' | translate }}"
                                                [emptyIfZero]="true"
                                                [decimal]="true"></form-number>
                                        </div>
                                        <div class="col">
                                            <form-number
                                                formControlName="volume"
                                                labelText="{{ 'Volume' | translate }}"
                                                [emptyIfZero]="true"
                                                [decimal]="true"></form-number>
                                        </div>
                                        <div class="col">
                                            <form-dropdown
                                                formControlName="volumeUnitOfMeasureId"
                                                labelText="{{ 'Volume Unit' | translate }}"
                                                codeListName="UnitOfMeasureOnlyVolumePerSystem"></form-dropdown>
                                        </div>
                                    </div>
                                </div>
                            }

                            @if (!isEditMode) {
                                <div class="mt-2">
                                    <button class="btn btn-sm btn-primary" (click)="addItem()">
                                        <fa-icon [icon]="['fas', 'plus']"></fa-icon>
                                        {{ 'Add' | translate }}
                                    </button>
                                </div>
                            }
                        </div>
                    </form>
                </ng-template>
            </app-loader>
        </div>

        <div class="modal-footer">
            <button class="btn btn-sm btn-primary mr-2" [disabled]="!form.valid" (click)="addNewDeliveryOrder()">
                <fa-icon [icon]="['fas', isEditMode ? 'check' : 'plus']"></fa-icon>
                &nbsp;{{ isEditMode ? ('Save' | translate) : ('Add' | translate) }}
            </button>
            <button class="btn btn-sm btn-secondary" (click)="activeModal.close(false)">
                <fa-icon [icon]="['fas', 'times']"></fa-icon>
                &nbsp;&nbsp;{{ 'Cancel' | translate }}
            </button>
        </div>
    </ng-template>
</app-loader>
